var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDribbbleLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89422 2.33273C10.6367 4.56549 12.5999 6.70765 13.9008 8.96775M13.9008 8.96775C14.7751 10.4868 15.3502 12.0591 15.6616 13.748M13.9008 8.96775C15.7963 8.0159 17.6042 6.65055 19.3911 4.83069M13.9008 8.96775C10.3583 10.7466 6.50964 11.0813 1.91936 10.2395M15.6616 13.748C16.1084 16.1705 16.0125 18.8329 15.4789 21.9221M15.6616 13.748C12.4065 14.6677 9.41105 16.7329 6.14975 20.1897M15.6616 13.748C17.735 13.1622 19.9137 13.0411 22.3335 13.3212M15.4789 21.9221C15.4752 21.9439 15.4714 21.9657 15.4676 21.9875M15.4789 21.9221C19.5745 20.4861 22.5114 16.586 22.5114 12C22.5114 6.19464 17.8052 1.48846 11.9998 1.48846C6.19446 1.48846 1.48828 6.19464 1.48828 12C1.48828 17.8054 6.19445 22.5115 11.9998 22.5115C13.2192 22.5115 14.39 22.3039 15.4789 21.9221Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleLine);
export default __webpack_public_path__ + "static/media/dribbble_line.ce826af864149957ab503801f0e7143b.svg";
export { ForwardRef as ReactComponent };